/*
  kant° — MODULAR im Warenkorb (Nov. 2026)

  1) Warenkorb (Seite + Drawer): Jedes MODULAR-Paket bekommt unter dem Titel
     seine Konfiguration und Anordnung. Liegen mehrere MODULAR-Pakete im
     Warenkorb, erscheint darüber ein Hinweis.
  2) Konfigurator: Liegt schon ein MODULAR im Warenkorb, fragt der Button
     „In den Warenkorb", ob die neue Konfiguration die alte ersetzen oder
     zusätzlich dazukommen soll.

  Pakete werden über das Line-Item-Property _KonfigId erkannt (gesetzt von
  sections/kant-konfigurator.liquid). Eingebunden in layout/theme.liquid.
*/
(function () {
  'use strict';

  var lang = (document.documentElement.lang || 'de').slice(0, 2);
  var T = {
    de: {
      config: 'Konfiguration',
      multi: function (n) { return 'Im Warenkorb liegen ' + n + ' MODULAR-Regale. Wenn du nur eines bestellen möchtest, entferne die anderen über das Papierkorb-Symbol.'; },
      askOne: function (l) { return 'Im Warenkorb liegt bereits ein MODULAR (' + l + ').'; },
      askMany: function (n) { return 'Im Warenkorb liegen bereits ' + n + ' MODULAR-Regale.'; },
      replace: 'Ersetzen',
      replaceAll: 'Alle ersetzen',
      add: 'Zusätzlich hinzufügen',
      busy: 'Einen Moment …',
      error: 'Das hat nicht geklappt. Bitte versuche es erneut.'
    },
    en: {
      config: 'Configuration',
      multi: function (n) { return 'There are ' + n + ' MODULAR shelves in your cart. If you only want one, remove the others with the bin icon.'; },
      askOne: function (l) { return 'Your cart already contains a MODULAR (' + l + ').'; },
      askMany: function (n) { return 'Your cart already contains ' + n + ' MODULAR shelves.'; },
      replace: 'Replace it',
      replaceAll: 'Replace all',
      add: 'Add as additional shelf',
      busy: 'One moment …',
      error: 'Something went wrong. Please try again.'
    },
    fr: {
      config: 'Configuration',
      multi: function (n) { return 'Votre panier contient ' + n + ' étagères MODULAR. Si vous n’en voulez qu’une, retirez les autres avec l’icône corbeille.'; },
      askOne: function (l) { return 'Votre panier contient déjà une MODULAR (' + l + ').'; },
      askMany: function (n) { return 'Votre panier contient déjà ' + n + ' étagères MODULAR.'; },
      replace: 'Remplacer',
      replaceAll: 'Tout remplacer',
      add: 'Ajouter en plus',
      busy: 'Un instant …',
      error: 'Une erreur est survenue. Veuillez réessayer.'
    }
  };
  var t = T[lang] || T.de;

  var CONFIG_KEYS = ['Konfiguration', 'Configuration'];
  var ARR_KEYS = ['Anordnung', 'Arrangement', 'Disposition'];

  function prop(item, keys) {
    var p = item.properties || {};
    for (var i = 0; i < keys.length; i++) if (p[keys[i]]) return p[keys[i]];
    return '';
  }

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); });
  }

  // Gruppiert die Warenkorb-Positionen nach _KonfigId (Reihenfolge wie im Warenkorb, neueste zuerst).
  function bundlesOf(cart) {
    var order = [], map = {};
    (cart.items || []).forEach(function (item) {
      var id = item.properties && item.properties._KonfigId;
      if (!id) return;
      if (!map[id]) { map[id] = { id: id, keys: [], label: '', arrangement: '' }; order.push(map[id]); }
      var b = map[id];
      b.keys.push(item.key);
      if (!b.label) b.label = prop(item, CONFIG_KEYS);
      if (!b.arrangement) b.arrangement = prop(item, ARR_KEYS);
      if (!b.label) {
        var m = /\(([^)]+)\)/.exec((item.properties && (item.properties['Gehört zu'] || item.properties['Belongs to'] || item.properties['Fait partie de'])) || '');
        if (m) b.label = m[1];
      }
    });
    return order;
  }

  /* ---------------- 1) Warenkorb-Anzeige ---------------- */

  var labelling = false, pending = false;

  function labelCart() {
    var rows = document.querySelectorAll('.cart-items__table-row--bundle');
    if (!rows.length) return;
    var todo = false;
    rows.forEach(function (row) { if (!row.querySelector('.kant-bundle-config')) todo = true; });
    var tables = document.querySelectorAll('.cart-items__table');
    tables.forEach(function (tb) {
      var n = tb.querySelectorAll('.cart-items__table-row--bundle').length;
      var note = tb.parentNode.querySelector(':scope > .kant-bundle-note');
      if ((n > 1) !== !!note) todo = true;
    });
    if (!todo) return;
    if (labelling) { pending = true; return; }
    labelling = true;

    getCart().then(function (cart) {
      var byKey = {};
      bundlesOf(cart).forEach(function (b) { b.keys.forEach(function (k) { byKey[k] = b; }); });

      document.querySelectorAll('.cart-items__table-row--bundle').forEach(function (row) {
        if (row.querySelector('.kant-bundle-config')) return;
        var b = byKey[row.getAttribute('data-key')];
        if (!b || !b.label) return;
        var title = row.querySelector('.cart-items__title');
        var anchor = title ? title.closest('p') || title : null;
        if (!anchor) return;
        var p = document.createElement('p');
        p.className = 'kant-bundle-config';
        p.textContent = t.config + ': ' + b.label;
        if (b.arrangement) {
          var s = document.createElement('span');
          s.className = 'kant-bundle-arrangement';
          s.textContent = b.arrangement;
          p.appendChild(s);
        }
        anchor.insertAdjacentElement('afterend', p);
      });

      document.querySelectorAll('.cart-items__table').forEach(function (tb) {
        var n = tb.querySelectorAll('.cart-items__table-row--bundle').length;
        var holder = tb.parentNode;
        var note = holder.querySelector(':scope > .kant-bundle-note');
        if (n > 1) {
          if (!note) {
            note = document.createElement('p');
            note.className = 'kant-bundle-note';
            note.setAttribute('role', 'note');
            holder.insertBefore(note, tb);
          }
          note.textContent = t.multi(n);
        } else if (note) {
          note.remove();
        }
      });
    }).catch(function () { /* Anzeige ist nur Zusatz — Warenkorb funktioniert ohne */ })
      .then(function () {
        labelling = false;
        if (pending) { pending = false; setTimeout(labelCart, 50); }
      });
  }

  /* ---------------- 2) Konfigurator-Abfrage ---------------- */

  var bypass = false;

  function closeChoice(root) {
    var box = root && root.querySelector('.kant-cart-choice');
    if (box) box.remove();
  }

  function proceed(cta) {
    bypass = true;
    try { cta.click(); } finally { bypass = false; }
  }

  function showChoice(cta, bundles) {
    var root = cta.closest('.km-root') || document;
    closeChoice(root);
    var box = document.createElement('div');
    box.className = 'kant-cart-choice';
    box.setAttribute('role', 'group');

    var msg = document.createElement('p');
    msg.className = 'kant-cart-choice__text';
    msg.textContent = bundles.length === 1 ? t.askOne(bundles[0].label || 'MODULAR') : t.askMany(bundles.length);
    box.appendChild(msg);

    var actions = document.createElement('div');
    actions.className = 'kant-cart-choice__actions';

    var bReplace = document.createElement('button');
    bReplace.type = 'button';
    bReplace.className = 'button';
    bReplace.textContent = bundles.length === 1 ? t.replace : t.replaceAll;

    var bAdd = document.createElement('button');
    bAdd.type = 'button';
    bAdd.className = 'button button-secondary';
    bAdd.textContent = t.add;

    actions.appendChild(bReplace);
    actions.appendChild(bAdd);
    box.appendChild(actions);

    var err = document.createElement('p');
    err.className = 'kant-cart-choice__error';
    err.setAttribute('role', 'status');
    box.appendChild(err);

    bReplace.addEventListener('click', function () {
      bReplace.disabled = bAdd.disabled = true;
      err.textContent = t.busy;
      var updates = {};
      bundles.forEach(function (b) { b.keys.forEach(function (k) { updates[k] = 0; }); });
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates: updates })
      })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
        .then(function () { box.remove(); proceed(cta); })
        .catch(function () { bReplace.disabled = bAdd.disabled = false; err.textContent = t.error; });
    });

    bAdd.addEventListener('click', function () {
      box.remove();
      proceed(cta);
    });

    var anchor = root.querySelector ? root.querySelector('#km-msg') : null;
    if (anchor) anchor.insertAdjacentElement('beforebegin', box);
    else cta.insertAdjacentElement('afterend', box);
    bReplace.focus({ preventScroll: true });
  }

  document.addEventListener('click', function (e) {
    if (bypass) return;
    var cta = e.target.closest && e.target.closest('#km-cta');
    if (!cta || cta.disabled) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (cta.dataset.kantChecking === '1') return;
    cta.dataset.kantChecking = '1';
    getCart()
      .then(function (cart) {
        var bundles = bundlesOf(cart);
        if (!bundles.length) { proceed(cta); return; }
        showChoice(cta, bundles);
      })
      // Wenn die Abfrage scheitert, lieber ganz normal hinzufügen als blockieren.
      .catch(function () { proceed(cta); })
      .then(function () { delete cta.dataset.kantChecking; });
  }, true);

  // Ändert sich die Konfiguration, passt die offene Frage nicht mehr.
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.km-row, #km-add')) {
      closeChoice(e.target.closest('.km-root'));
    }
  });

  /* ---------------- Styles ---------------- */

  var css =
    '.kant-bundle-config{color:var(--color-foreground);}' +
    '.kant-bundle-arrangement{display:block;opacity:.7;}' +
    '.kant-bundle-note{margin:0 0 var(--margin-md,16px);padding:10px 12px;border:1px solid var(--color-border);font-size:var(--font-size--sm,14px);line-height:1.45;}' +
    '.kant-cart-choice{margin-top:12px;padding:12px;border:1px solid var(--color-foreground);font-size:13px;line-height:1.45;}' +
    '.kant-cart-choice__text{margin:0 0 10px;}' +
    '.kant-cart-choice__actions{display:grid;grid-template-columns:1fr 1fr;gap:8px;}' +
    '.kant-cart-choice__actions .button{width:100%;min-height:40px;padding:8px 10px;font-size:13px;}' +
    '.kant-cart-choice__error{margin:8px 0 0;font-size:12px;opacity:.75;min-height:0;}' +
    '.kant-cart-choice__error:empty{display:none;}' +
    // Schmaler Warenkorb: Beschreibung des Pakets über volle Breite, Preis neben den Papierkorb.
    '@container cart-items (max-width: 480px){' +
      '.cart-items__table-row--bundle{grid-template-columns:clamp(2.5rem,15cqi,7.5rem) minmax(0,1fr) auto;' +
      "grid-template-areas:'media details details' 'media quantity price' 'media error error';}" +
      '.cart-items__table-row--bundle .cart-items__price{align-self:center;}' +
    '}';
  var st = document.createElement('style');
  st.textContent = css;
  document.head.appendChild(st);

  /* ---------------- Start ---------------- */

  var timer = null;
  function schedule() { clearTimeout(timer); timer = setTimeout(labelCart, 120); }

  function start() {
    labelCart();
    new MutationObserver(function (list) {
      for (var i = 0; i < list.length; i++) {
        var tg = list[i].target;
        if (tg.nodeType === 1 && (tg.closest('.kant-bundle-config, .kant-bundle-note, .kant-cart-choice'))) continue;
        schedule();
        return;
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
